import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-6 p-fluid" }
const _hoisted_3 = { class: "p-float-label p-m-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "kn-material-input-label" }
const _hoisted_6 = { class: "p-col-6 p-fluid" }
const _hoisted_7 = { class: "p-float-label p-m-2" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "kn-material-input-label" }
const _hoisted_10 = { class: "p-col-6 p-fluid" }
const _hoisted_11 = { class: "p-float-label p-m-2" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "kn-material-input-label" }
const _hoisted_14 = { class: "p-col-6" }
const _hoisted_15 = { class: "p-d-flex p-flex-column p-m-2" }
const _hoisted_16 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_ColorPicker = _resolveComponent("ColorPicker")
  const _component_Card = _resolveComponent("Card")

  return (_ctx.font)
    ? (_openBlock(), _createBlock(_component_Card, {
        key: 0,
        class: "p-m-2"
      }, {
        header: _withCtx(() => [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
            start: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.style')), 1)
            ]),
            _: 1
          })
        ]),
        content: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", _hoisted_3, [
                _createVNode(_component_Dropdown, {
                  class: "kn-material-input",
                  modelValue: _ctx.font.size,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.font.size = $event)),
                  options: _ctx.KpiDocumentDesignerStyleCardDescriptor.fontSizeOptions,
                  optionValue: "value"
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value)
                      ? (_openBlock(), _createBlock("div", _hoisted_4, [
                          _createVNode("span", null, _toDisplayString(_ctx.getDropdownValueLabel(slotProps.value, _ctx.KpiDocumentDesignerStyleCardDescriptor.fontSizeOptions)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  option: _withCtx((slotProps) => [
                    _createVNode("span", {
                      style: 'font-size: ' + slotProps.option.value
                    }, _toDisplayString(_ctx.$t(slotProps.option.label)), 5)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"]),
                _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.fontSize')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, [
                _createVNode(_component_Dropdown, {
                  class: "kn-material-input",
                  modelValue: _ctx.font.fontFamily,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.font.fontFamily = $event)),
                  options: _ctx.KpiDocumentDesignerStyleCardDescriptor.fontFamilyOptions,
                  optionValue: "value"
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value)
                      ? (_openBlock(), _createBlock("div", _hoisted_8, [
                          _createVNode("span", null, _toDisplayString(_ctx.getDropdownValueLabel(slotProps.value, _ctx.KpiDocumentDesignerStyleCardDescriptor.fontFamilyOptions)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  option: _withCtx((slotProps) => [
                    _createVNode("span", {
                      style: 'font-family: ' + slotProps.option.value
                    }, _toDisplayString(_ctx.$t(slotProps.option.label)), 5)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"]),
                _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.fontSize')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, [
                _createVNode(_component_Dropdown, {
                  class: "kn-material-input",
                  modelValue: _ctx.font.fontWeight,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.font.fontWeight = $event)),
                  options: _ctx.KpiDocumentDesignerStyleCardDescriptor.fontWeightOptions,
                  optionValue: "value"
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value)
                      ? (_openBlock(), _createBlock("div", _hoisted_12, [
                          _createVNode("span", null, _toDisplayString(_ctx.getDropdownValueLabel(slotProps.value, _ctx.KpiDocumentDesignerStyleCardDescriptor.fontWeightOptions)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  option: _withCtx((slotProps) => [
                    _createVNode("span", {
                      style: 'font-weight: ' + slotProps.option.value
                    }, _toDisplayString(_ctx.$t(slotProps.option.label)), 5)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"]),
                _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.fontWeight.title')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.color')), 1),
                _createVNode(_component_ColorPicker, {
                  modelValue: _ctx.font.color,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.font.color = $event)),
                  format: "rgb",
                  inline: false
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}